import { Link } from 'react-router';

import { Button } from '@/components/ui/button.js';

export function NotFound() {
  return (
    <section>
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="mt-2 text-muted-foreground">That address does not exist in the app.</p>
      <Button asChild className="mt-6">
        <Link to="/chat">Go to Chat</Link>
      </Button>
    </section>
  );
}
